<template>
    <div class="error-wrapper">
        <div class="container">

            <div class="error-heading">
                <h2 class="headline font-danger">404</h2>
            </div>
            <div class="col-md-8 offset-md-2">
                <p class="sub-content font-danger">ไม่พบข้อมูลสินค้า (Product not found).</p>
            </div>
            <!-- <div><router-link class="btn btn-danger-gradien btn-lg" to="/">
                    BACK TO HOME PAGE</router-link></div> -->
        </div>
    </div>
</template>